<template>
  <div>
    <page-header :title="$t('bill.domain_cost')">
      <div slot="res-status-tab" style="position: absolute; right: 0; top: 10px;">
        <bill-config :billShared.sync="billShared" :projectShared.sync="projectShared" :projectSharedShow="projectSharedShow" @update:currency="currencyChange" />
      </div>
    </page-header>
    <page-body>
      <clouddomain-list :id="listId" :billShared="billShared" :projectShared="projectShared" />
    </page-body>
  </div>
</template>

<script>
import shareMixin from '@Bill/mixins/share'
import BillConfig from '@Bill/sections/BillConfig'
import ClouddomainList from './components/List'

export default {
  name: 'CloudDomainIndex',
  components: {
    ClouddomainList,
    BillConfig,
  },
  mixins: [shareMixin],
  data () {
    return {
      listId: 'CloudDomainList',
    }
  },
}
</script>
